// 转换价格 分=> 元
export let transform = (num) => {
  return Number.isInteger(num) ? (num / 100).toFixed(2) : num;
}
/**
 * 复制方法
 * @param value {string} value 需要复制的文本
 * @return isCopy {boolean}  是否能被复制
 */
export let copy = value => {
  const input = document.createElement("input");
  input.setAttribute("readonly", "readonly");
  input.setAttribute("value", value);
  document.body.appendChild(input);
  input.setSelectionRange(0, 9999);
  let isCopy = document.execCommand("copy");
  if (isCopy) {
    input.select(); // 选中文本
    document.execCommand("copy");
    //console.log("复制成功");
  }
  document.body.removeChild(input);
  return isCopy;
};
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}



// WEBPACK FOOTER //
// ./src/until/utils.js